<div class="search-box">
  <span *ngIf="allowClose" class="close" (click)="close.emit($event)">X</span>
  <!-- <textarea class="tags-search"
  rows="1"
  [placeholder]="placeholder"
  [ngModel]="input"
  (ngModelChange)="onInputChange($event)"
  (keydown.enter)="onEnter($event)"
  ></textarea> -->

  <input class="tags-search"
    [placeholder]="placeholder"
    [ngModel]="input"
    (ngModelChange)="onInputChange($event)"
    (keydown.enter)="onEnter($event)"
  >

  <div class="with-tags" [hidden]="input.length==0 || (labels != null && (labels.length==0 && labelsExcluded.length == 0))">
    <span class="with-tags-title" [hidden]="foundText == ''">{{foundText}}</span>
    <!-- excluded labels added as dimmed no action tags in results -->
 
    <div class="loader" *ngIf="input.length!=0 && searching && labels == null">
      <div class="dimmed">
        <div class="dimmed_content">
          <div class="dimmed_flex">
            <span class="dimmed_tag"></span>
            <span class="dimmed_tag"></span>
            <span class="dimmed_tag"></span>
          </div>
        </div>
      </div>
      <!-- <core-helpers-box-loading></core-helpers-box-loading> -->
    </div>
    <core-labels-list-excluded [excluded]="labelsExcluded" [labels]="labels" (choose)="selectLabel($event)"></core-labels-list-excluded>
    <app-helpers-labels-add-box *ngIf="add"
      [input]="input"
      [buttonText]="'Add as New Tag'"
    ></app-helpers-labels-add-box>
  </div>

  <div class="no-tags" [hidden]="input.length==0 || (labels != null && (labels.length>0 || labelsExcluded.length > 0)) || (labels == null)">
    <span>We could not find any tags.</span>
    <!-- add label feature -->
    <app-helpers-labels-add-box *ngIf="add"
    [input]="input"
    ></app-helpers-labels-add-box>
  </div>

</div>
